"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizePathname_1 = require("./normalizePathname");
/**
 * Ensures that the given url ends with a trailing slash
 */
var ensureTrailingSlash = function (url) { return normalizePathname_1.stripTrailingSlash(url) + "/"; };
exports.default = ensureTrailingSlash;
